import Notify from './notify'
import { config } from './../config'
import store from 'vx/store'
import * as types from 'vx/mutation-types'

const fileEvents = {
  'dashboard-summary-csv-created': 'Dashboard data',
  'history-file-created': 'History slsx file'
}

/**
 * Bind events to pusher channel
 * @param  Pusher channel]
 * @return null
 */
export function bindEvents(channel) {
  // binding file download events
  for (const eventName in fileEvents) {
    channel.bind(eventName, function (url) {
      dumpDownloadLink(fileEvents[eventName], url)
    })
  }
}

function dumpDownloadLink(file, url) {
  clearEventLoading();

  Notify.success(
    `${file} generated, click <a href="${config.API_PATH}/${url}" target="_blank"><b>here</b></a> to download`,
    { timeout: 0 }
  );
}

export function clearEventLoading() {
  $('#toast-container').remove();
  store.dispatch(types.SET_EVENT_LOADING, false);
}

export function startEvent(type) {
  store.dispatch(types.SET_EVENT_LOADING, true);
  Notify.success(`${type} data generating...`, { timeout: 0 });
}



// WEBPACK FOOTER //
// ./src/utils/pusher.js